import React, { useState } from 'react';
import DeliveryFeed from './DeliveryFeed';
import { auth } from "../../../firebase/Firebase";
import {Link} from "react-router-dom"; // Path to your DeliveryFeed component

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('purchaserReview');
  const [userName, setUserName] = useState('');
  const [isDropdownVisible, setDropdownVisible] = useState(false);



  const handleSignOut = () => {
    auth?.signOut();
    localStorage.clear()
  };

  const styles = {
    tabsHeader: {
      display: 'flex',
      gap: '10px',
      borderBottom: '2px solid #ddd',
      padding: '10px 0',
      backgroundColor: '#ffffff',
    },
    button: {
      padding: '10px 15px',
      border: 'none',
      background: '#f5f5f5',
      cursor: 'pointer',
      borderRadius: '5px',
      transition: 'background 0.3s',
      marginLeft: 10,
    },
    activeButton: {
      background: '#FFC300',
      color: '#fff',
      fontWeight: 'bold',
    },
    container: {
      position: 'relative',
      marginLeft: 'auto',
      cursor: 'pointer',
    },
    menu: {
      position: 'absolute',
      top: '100%',
      right: 0,
      border: '1px solid #ddd',
      backgroundColor: '#fff',
      minWidth: '150px',
      zIndex: 1000,
    },
    menuItem: {
      padding: '10px',
      borderBottom: '1px solid #ddd',
      cursor: 'pointer',
      fontWeight: 500,
      fontSize: 14,
    },
    accountText: {
      fontWeight: 'bold',
      fontSize: '16px',
    },
  };

  const DropdownMenu = () => {
    return (
      <div style={styles.menu}>
        <div style={styles.menuItem}>
          Plan: Free Tier
        </div>
        <div style={styles.menuItem}>
          <Link
            to="/dashboard/settings"
            style={{ textDecoration: 'none', color: '#000' }}
          >
            Settings
          </Link>
        </div>
        <div style={styles.menuItem}>
          Resource Center
        </div>
        <div style={styles.menuItem} onClick={handleSignOut}>
          Sign Out
        </div>
      </div>
    );
  };

  return (
    <div>
      <div style={styles.tabsHeader}>
        <button
          style={{...styles.button, ...(activeTab === 'purchaserReview' ? styles.activeButton : {})}}
          onClick={() => setActiveTab('purchaserReview')}>
          Purchaser Review
        </button>
        <button
          style={{...styles.button, ...(activeTab === 'accountingReview' ? styles.activeButton : {})}}
          onClick={() => setActiveTab('accountingReview')}>
          Accounting Review
        </button>
        <button
          style={{...styles.button, ...(activeTab === 'archive' ? styles.activeButton : {})}}
          onClick={() => setActiveTab('archive')}>
          Archive
        </button>
        <div style={styles.container} onClick={() => setDropdownVisible(!isDropdownVisible)}>
          <div style={styles.accountText}>Account</div>
          {isDropdownVisible && <DropdownMenu />}
        </div>
      </div>
      {activeTab === 'purchaserReview' && <DeliveryFeed stage={'Purchaser'}/>}
      {activeTab === 'accountingReview' && <DeliveryFeed stage={'Accounting'} />}
      {activeTab === 'archive' && <DeliveryFeed stage={'Archive'} />}
    </div>
  );
};

export default Dashboard
